// import React from "react";

// export default function Roadmap({ answers }) {
//   const { stage, goal, interest } = answers;

//   // Dynamic roadmap generator
//   const getRoadmapSteps = () => {
//     let steps = [];

//     if (stage === "Student") {
//       steps.push("Focus on building strong fundamentals.");
//       if (goal === "Career Guidance") steps.push("Explore multiple career options with aptitude tests.");
//       if (goal === "Skill Development") steps.push("Start with beginner-friendly courses in your interest area.");
//       if (goal === "Job Placement") steps.push("Build projects and internships to prepare for campus placements.");
//     }

//     if (stage === "Graduate") {
//       steps.push("Refine skills with advanced certifications.");
//       if (goal === "Career Guidance") steps.push("Get mentorship on aligning degree with career opportunities.");
//       if (goal === "Skill Development") steps.push("Take specialized courses for industry-ready expertise.");
//       if (goal === "Job Placement") steps.push("Build a strong portfolio and practice mock interviews.");
//     }

//     if (stage === "Professional") {
//       steps.push("Leverage work experience to move into leadership or niche roles.");
//       if (goal === "Career Guidance") steps.push("Seek mentorship for career transitions and growth.");
//       if (goal === "Skill Development") steps.push("Upskill with advanced tools, certifications, and executive programs.");
//       if (goal === "Job Placement") steps.push("Prepare for lateral shifts or global opportunities with networking.");
//     }

//     // Add personalized flavor for interest
//     if (interest === "Technology") {
//       steps.push("Learn coding, AI/ML, and stay updated with tech trends.");
//     } else if (interest === "Business") {
//       steps.push("Focus on strategy, entrepreneurship, and finance skills.");
//     } else if (interest === "Creative Arts") {
//       steps.push("Build a strong portfolio and share work on creative platforms.");
//     } else if (interest === "Science") {
//       steps.push("Engage in research projects and explore higher education options.");
//     }

//     return steps;
//   };

//   const roadmapSteps = getRoadmapSteps();

//   return (
//     <section id="roadmap" className="py-20 bg-gradient-to-r from-purple-100 to-blue-50">
//       <div className="max-w-3xl mx-auto text-center">
//         <h2 className="text-3xl font-bold mb-6">Your Personalized Roadmap 🚀</h2>

//         <p className="mb-4">Stage: <strong>{stage}</strong></p>
//         <p className="mb-4">Goal: <strong>{goal}</strong></p>
//         <p className="mb-4">Interest: <strong>{interest}</strong></p>

//         <div className="mt-6 space-y-4 text-left bg-white p-6 rounded-xl shadow-lg">
//           <h3 className="text-xl font-semibold mb-3 text-center">Next Steps</h3>
//           <ul className="list-disc pl-6 space-y-2 text-gray-700">
//             {roadmapSteps.map((step, idx) => (
//               <li key={idx}>{step}</li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </section>
//   );
// }
// import React from "react";

// export default function Roadmap({ answers }) {
//   const steps = [
//     {
//       title: "🎯 Self-Discovery",
//       desc: `Since you're a ${answers.stage}, we’ll first assess your strengths and interests.`,
//     },
//     {
//       title: "📚 Learning Path",
//       desc:
//         answers.goal === "Skill Development"
//           ? `Focus on hands-on courses in ${answers.interest}.`
//           : `Learn essential foundations to prepare for your chosen path.`,
//     },
//     {
//       title: "🧑‍💻 Practical Experience",
//       desc:
//         answers.goal === "Job Placement"
//           ? "Get resume workshops, mock interviews, and real projects."
//           : "Engage in projects, internships, or portfolio-building activities.",
//     },
//     {
//       title: "🚀 Career Growth",
//       desc: `Step confidently into opportunities in ${answers.interest} with guidance.`,
//     },
//   ];

//   return (
//     <section
//       id="roadmap"
//       className="relative py-20 bg-gradient-to-b from-purple-50 via-white to-pink-50"
//     >
//       <div className="max-w-4xl mx-auto px-6">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600">
//           Your Personalized Roadmap 🚀
//         </h2>

//         <div className="relative border-l-4 border-pink-400 pl-6">
//           {steps.map((step, idx) => (
//             <div key={idx} className="mb-10 relative">
//               {/* Timeline Dot */}
//               <span className="absolute -left-[22px] top-1.5 w-5 h-5 rounded-full bg-pink-500 border-4 border-white shadow-md"></span>

//               {/* Step Content */}
//               <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
//                 <h3 className="text-xl font-bold text-pink-600 mb-2">
//                   {step.title}
//                 </h3>
//                 <p className="text-gray-700 leading-relaxed">{step.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }
// import React from "react";

// export default function Roadmap({ answers }) {
//   const steps = [
//     {
//       title: "🎯 Self-Discovery",
//       desc: `Since you're a ${answers.stage}, we’ll first assess your strengths and interests.`,
//     },
//     {
//       title: "📚 Learning Path",
//       desc:
//         answers.goal === "Skill Development"
//           ? `Focus on hands-on courses in ${answers.interest}.`
//           : `Learn essential foundations to prepare for your chosen path.`,
//     },
//     {
//       title: "🧑‍💻 Practical Experience",
//       desc:
//         answers.goal === "Job Placement"
//           ? "Get resume workshops, mock interviews, and real projects."
//           : "Engage in projects, internships, or portfolio-building activities.",
//     },
//     {
//       title: "🚀 Career Growth",
//       desc: `Step confidently into opportunities in ${answers.interest} with guidance.`,
//     },
//   ];

//   return (
//     <section
//       id="roadmap"
//       className="relative py-20 bg-gradient-to-b from-purple-50 via-white to-pink-50"
//     >
//       <div className="max-w-4xl mx-auto px-6">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600">
//           Your Personalized Roadmap 🚀
//         </h2>

//         <div className="relative border-l-4 border-pink-400 pl-6">
//           {steps.map((step, idx) => (
//             <div key={idx} className="mb-10 relative">
//               {/* Timeline Dot */}
//               <span className="absolute -left-[22px] top-1.5 w-5 h-5 rounded-full bg-pink-500 border-4 border-white shadow-md"></span>

//               {/* Step Content */}
//               <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
//                 <h3 className="text-xl font-bold text-pink-600 mb-2">
//                   {step.title}
//                 </h3>
//                 <p className="text-gray-700 leading-relaxed">{step.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Sweet Closing Message */}
//         <div className="mt-16 text-center">
//           <h3 className="text-2xl font-semibold text-indigo-700">
//             🌟 Ready to take the next big step?
//           </h3>
//           <p className="mt-4 text-gray-700 max-w-2xl mx-auto leading-relaxed">
//             Your journey doesn’t end here — it’s just the beginning.  
//             With the right guidance, effort, and support, your dreams can turn into reality.  
//             Let’s dive deeper into building your future and unlock opportunities that are waiting for you. 🚀
//           </p>
//           <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-6">
//   {/* Contact CTA */}
//   <a
//     href="#contact"
//     className="px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-semibold shadow-lg hover:scale-105 transition flex items-center gap-2"
//   >
//     <span className="icon-heartbeat">💡</span>
//     Get In-Depth Guidance
//   </a>

//   {/* Direct Call Button with Heartbeat Icon */}
//   <a
//     href="tel:+919876543210" // replace with your number
//     className="px-6 py-3 rounded-full bg-gradient-to-r from-green-400 to-emerald-600 text-white font-semibold shadow-lg hover:scale-105 transition flex items-center gap-2"
//   >
//     <span className="icon-heartbeat">📞</span>
//     Call Us Now
//   </a>
// </div>


//         </div>
//       </div>
//     </section>
//   );
// }
import React from "react";

export default function Roadmap({ answers }) {
  const steps = [
    {
      title: "🎯 Self-Discovery & Awareness",
      desc: `As a ${answers.stage}, we'll first assess your strengths, interests, and aptitude to identify the best career direction.`,
    },
    {
      title: "📚 Structured Learning Path",
      desc:
        answers.goal === "Stream/Course Selection"
          ? `Guidance on choosing the right stream and courses aligned with ${answers.interest}.`
          : answers.goal === "Skill Development"
          ? `Focused skill-building courses and certifications in ${answers.interest}.`
          : `Clear, actionable plans tailored to your goal of ${answers.goal}.`,
    },
    {
      title: "🧑‍💻 Practical Experience & Mentoring",
      desc:
        answers.goal === "Job Placement"
          ? "ATS-friendly resume building, mock interviews, and real-world project experience."
          : answers.goal === "Career Switch"
          ? "Career transition coaching, updated resume, and interview preparation for your new direction."
          : "One-on-one mentorship, progress monitoring, and hands-on industry exposure.",
    },
    {
      title: "🚀 Career Growth & Success",
      desc: `Step confidently into opportunities in ${answers.interest} with structured guidance, networking, and continuous support.`,
    },
  ];

  return (
    <section
      id="roadmap"
      className="relative py-20 z-10 bg-gradient-to-br from-blue-50 via-white to-pink-50"
    >
      {/* Diagonal Stripes Background */}
      <div className="absolute inset-0 -z-10" style={{
          background: `
            radial-gradient(circle at 20% 20%, rgba(236, 72, 153, 0.15), transparent 40%),
            radial-gradient(circle at 80% 30%, rgba(59, 130, 246, 0.15), transparent 40%),
            radial-gradient(circle at 50% 80%, rgba(16, 185, 129, 0.15), transparent 40%)
          `,
        }} />

      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-600">
          Your Personalized Roadmap 🚀
        </h2>

        <div className="relative border-l-4 border-pink-400 pl-6">
          {steps.map((step, idx) => (
            <div key={idx} className="mb-10 relative">
              {/* Timeline Dot */}
              <span className="absolute -left-[22px] top-1.5 w-5 h-5 rounded-full bg-pink-500 border-4 border-white shadow-md"></span>

              {/* Step Content */}
              <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition">
                <h3 className="text-xl font-bold text-pink-600 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Sweet Closing Message */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-semibold text-indigo-700">
            🌟 Start Your Systematic Career Plan Today
          </h3>
          <p className="mt-4 text-gray-700 max-w-2xl mx-auto leading-relaxed">
            Your journey doesn't end here — it's just the beginning.  
            With the right decisions at the right time, your career can flourish.  
            Don't leave your career to chance — let us guide you at every stage. 🚀
          </p>

          <div className="mt-6 flex flex-col md:flex-row items-center justify-center gap-6">
            {/* Contact CTA */}
            <a
              href="#contact"
              className="px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-semibold shadow-lg hover:scale-105 transition flex items-center gap-2"
            >
              <span className="icon-heartbeat animate-pulse">💡</span>
              Book Your Consultation
            </a>

            {/* Direct Call Button */}
            <a
              href="tel:+919920405421"
              className="px-6 py-3 rounded-full bg-gradient-to-r from-green-400 to-emerald-600 text-white font-semibold shadow-lg hover:scale-105 transition flex items-center gap-2"
            >
              <span className="icon-heartbeat animate-pulse">📞</span>
              Call Us Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}